//This set to use Production Mode or DevelopmentMode
export const IsProdMode = true;
export const IsTestMode = false;

export const IsEncryption = true;

export const IsQueryParamsEncryption = true;

export const IsCookieEncryption = true;
